import { render, staticRenderFns } from "./EarlyWarningConfig.vue?vue&type=template&id=1084f056&scoped=true&"
import script from "./EarlyWarningConfig.vue?vue&type=script&lang=ts&"
export * from "./EarlyWarningConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EarlyWarningConfig.vue?vue&type=style&index=0&id=1084f056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084f056",
  null
  
)

export default component.exports